export class Roleassign {
    name: string;
    description: string;
    userObjectId: number;
    read:boolean;
    crud:boolean;
    companyName:string;

}
